import Axios from "axios";
import * as Firebase from "firebase/app";
import "firebase/auth";

const Api = Axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Client-Build": process.env.VUE_APP_BUILD
  }
});
Api.interceptors.request.use(config => {
  if (!config.hasOwnProperty("retry")) {
    config.retry = 2;
  }
  return config;
});
Api.interceptors.response.use(null, error => {
  if (error.config && error.response) {
    if (error.response.status === 401 || error.response.status === 403) {
      if (error.config.retry > 0) {
        return Firebase.auth()
          .currentUser.getIdToken(true)
          .then(idToken => {
            Api.defaults.headers.common["Authorization"] = idToken;
            error.config.headers.Authorization = idToken;
            error.config.retry = error.config.retry - 1;
            return Api.request(error.config);
          })
          .catch(error => {
            logOut();
            return Promise.reject(error);
          });
      } else {
        logOut();
        return Promise.reject(error);
      }
    } else if ([408, 502, 503, 504].indexOf(error.response.status) !== -1) {
      if (error.config.retry > 0) {
        error.config.retry = error.config.retry - 1;
        return Api.request(error.config);
      }
    } else if (error.response.status === 409) {
      location.reload();
    }
  }
  return Promise.reject(error);
});
const logOut = () => {
  Firebase.auth().signOut();
};

export default Api;
